// src/components/UI/StarRating.js
import React, { useState } from 'react';
import styles from './StarRating.module.css';
import { FaStar } from 'react-icons/fa';

const StarRating = ({ count = 5, rating = 0, onRate, disabled = false, size = 24 }) => {
  const [hoverRating, setHoverRating] = useState(0);

  const handleMouseEnter = (index) => {
    if (!disabled) {
      setHoverRating(index);
    }
  };

  const handleMouseLeave = () => {
    if (!disabled) {
      setHoverRating(0);
    }
  };

  const handleClick = (index) => {
    if (!disabled) {
      onRate(index); // Pass the rating (1-based index)
    }
  };

  return (
    <div className={`${styles.starRatingContainer} ${disabled ? styles.disabled : ''}`}>
      {[...Array(count)].map((_, i) => {
        const ratingValue = i + 1;
        let starClass = styles.star;
        if (!disabled && hoverRating >= ratingValue) {
          starClass += ` ${styles.hover}`;
        } else if (rating >= ratingValue) {
          starClass += ` ${styles.active}`;
        }

        return (
          <span
            key={ratingValue}
            className={starClass}
            onMouseEnter={() => handleMouseEnter(ratingValue)}
            onMouseLeave={handleMouseLeave}
            onClick={() => handleClick(ratingValue)}
            style={{ fontSize: `${size}px` }} // Apply size prop
            aria-label={`Rate ${ratingValue} out of ${count} stars`}
            role="radio" // Semantically like radio buttons
            aria-checked={rating === ratingValue}
            tabIndex={disabled ? -1 : 0} // Allow keyboard focus if not disabled
             onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && handleClick(ratingValue)} // Allow selection with Enter/Space
          >
            <FaStar />
          </span>
        );
      })}
    </div>
  );
};

export default StarRating;